export const USER = 'USER';
export const SINGLE_USER = 'SINGLE_USER';
export const USER_GROUPS = 'USER_GROUPS';
export const USER_PROFILE = 'USER_PROFILE';
export const DELETED_USER = 'DELETED_USER';
